// extracted by mini-css-extract-plugin
module.exports = {"video-container":"kVideoPlayer_video-container__1LQWE"};